/**
 * Button that shows a spinner and disables itself while `loading` — template §12.
 *
 * Drop-in replacement for any async-action <button>. Every other prop passes straight through.
 * Template §0.8 makes this a RULE, not a preference: inconsistent loading feedback is the single
 * most common source of double-submits.
 */
export default function LoadingButton({
  loading = false,
  disabled = false,
  loadingText,
  spinnerOnly = false,
  className = "btn btn-primary",
  type = "button",
  children,
  ...rest
}) {
  const spinner = (
    <span
      className={`spinner-border spinner-border-sm${spinnerOnly ? "" : " me-2"}`}
      role="status"
      aria-hidden="true"
    />
  );

  // `aria-busy` alongside `disabled`: disabled says "you cannot press this", busy says "because it
  // is working". Without it a screen-reader user hears only that the control went dead.
  return (
    <button type={type} className={className} disabled={loading || disabled}
      aria-busy={loading ? "true" : "false"} {...rest}>
      {loading ? (
        <>
          {spinner}
          {!spinnerOnly && (loadingText ?? children)}
        </>
      ) : (
        children
      )}
    </button>
  );
}
